export const environmentVariables = {
  REACT_APP_HTTP_REQUEST_LOG_CONSOLE:
    process.env.REACT_APP_HTTP_REQUEST_LOG_CONSOLE,
  REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_CI_ENVIRONMENT: process.env.REACT_APP_CI_ENVIRONMENT,
  REACT_APP_API_HOST: process.env.REACT_APP_API_HOST,
  REACT_APP_APPLICATION_ID: process.env.REACT_APP_APPLICATION_ID,
  REACT_APP_CLOUDSEARCH_DOMAIN: process.env.REACT_APP_CLOUDSEARCH_DOMAIN,
  REACT_APP_MEDIA_BUCKET_URL: process.env.REACT_APP_MEDIA_BUCKET_URL,
  RAYGUN_KEY: process.env.REACT_APP_RAYGUN_KEY,
  CONSUMER_SITE: process.env.REACT_APP_CONSUMER_SITE,
};

export const isProduction = () =>
  environmentVariables.REACT_APP_CI_ENVIRONMENT === 'production';
